import React from 'react';
import { Bot, User } from 'lucide-react';

const SimpleChatMessage = ({ message, isUser = false }) => {
  const getActionIcon = () => {
    switch (message.action) {
      case 'TABLE_REQUEST':
        return '📊';
      case 'REAL_ESTATE_CALCULATION':
        return '🧮';
      case 'IMAGE_ANALYSIS':
        return '📷';
      case 'MARKET_ANALYSIS':
        return '📈';
      default:
        return <Bot className="w-4 h-4 text-blue-400" />;
    }
  };

  const getActionLabel = () => {
    switch (message.action) {
      case 'TABLE_REQUEST':
        return 'Table Generated';
      case 'REAL_ESTATE_CALCULATION':
        return 'Calculation Complete';
      case 'IMAGE_ANALYSIS':
        return 'Image Analysis';
      case 'MARKET_ANALYSIS':
        return 'Market Analysis';
      case 'PROPERTY_ANALYSIS':
        return 'Property Search';
      case 'WEB_SEARCH':
        return 'Web Search';
      default:
        return 'AI Assistant';
    }
  };

  // Truncate long messages for sidebar
  const truncateMessage = (text, maxLength = 100) => {
    if (!text || text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  return (
    <div className={`flex gap-3 p-3 rounded-lg ${
      isUser 
        ? 'bg-blue-900/20 border-l-2 border-blue-500' 
        : 'bg-gray-800/50 border-l-2 border-gray-600'
    }`}>
      {/* Avatar */}
      <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center ${
        isUser ? 'bg-blue-600' : 'bg-gray-700'
      }`}>
        {isUser ? <User className="w-3 h-3 text-white" /> : (
          typeof getActionIcon() === 'string' ? (
            <span className="text-xs">{getActionIcon()}</span>
          ) : getActionIcon()
        )}
      </div>

      {/* Message Content */}
      <div className="flex-1 min-w-0">
        {/* Message Header */}
        <div className="flex items-center gap-2 mb-1">
          <span className="text-xs font-medium text-gray-300">
            {isUser ? 'You' : getActionLabel()}
          </span>
          {message.timestamp && (
            <span className="text-xs text-gray-500">
              {new Date(message.timestamp).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
            </span>
          )}
        </div>

        {/* Simplified Text Content */}
        {message.content && (
          <div className="text-gray-200 text-xs leading-relaxed">
            {truncateMessage(message.content)}
          </div>
        )}

        {/* Simple Indicators for Special Content */}
        {message.tableData && (
          <div className="mt-1 text-xs text-blue-400 flex items-center gap-1">
            📊 Table generated - View in main area
          </div>
        )}

        {message.calculationResult && (
          <div className="mt-1 text-xs text-green-400 flex items-center gap-1">
            🧮 Calculation complete - View in main area
          </div>
        )}

        {message.imageAnalysis && (
          <div className="mt-1 text-xs text-purple-400 flex items-center gap-1">
            📷 Image analysis complete - View in main area
          </div>
        )}

        {message.shouldTriggerPropertySearch && message.address && (
          <div className="mt-1 text-xs text-blue-400 flex items-center gap-1">
            🏠 Property search: {message.address}
          </div>
        )}
      </div>
    </div>
  );
};

export default SimpleChatMessage;